import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "career-section" }
const _hoisted_5 = { class: "career-list-content" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "career-list" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "career-box" }
const _hoisted_10 = { class: "career-location" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "career-des" }
const _hoisted_13 = { class: "career-read-more" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_userFooter = _resolveComponent("userFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader, { ref: "userHeader" }, null, 512),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", {
        class: "page-banner-section",
        style: _normalizeStyle({ 'background-image': `url(${require('@/assets/images/career-banner.jpg')})` })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.constants['CAREER_TEXT']), 1)
        ])
      ], 4),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.constants['CURRENT_JOBS_TEXT']), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobsData, (job) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-sm-4",
                    key: job.id
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h3", null, _toDisplayString(job.jobTitle), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createTextVNode(" Location - " + _toDisplayString(job.location), 1),
                        _hoisted_11,
                        _createTextVNode(" Requirements - " + _toDisplayString(job.requiredExperience.from) + "-" + _toDisplayString(job.requiredExperience.to) + " Years Exp ", 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.useStripHtml(_ctx.getTruncatedText(job.shortDescription, 130))), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_router_link, {
                          to: `/career/${job.slug}`,
                          class: "primary-btn-outline",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeMenu()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Read More >>")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_userFooter)
  ]))
}